import PropTypes from "prop-types";

/**
 * Callback PropTypes
 * Reusable PropTypes for common event handler callbacks used across components
 */

/**
 * PropType for click event handler callback
 * Standard onClick handler that receives a click event
 * @type {PropTypes.Requireable<function>}
 */
export const onClickPropType = PropTypes.func;

/**
 * PropType for change event handler callback
 * Used in form inputs to handle value changes
 * Typically receives the new value or event object
 * @type {PropTypes.Requireable<function>}
 */
export const onChangePropType = PropTypes.func;

/**
 * PropType for submit event handler callback
 * Used in forms to handle form submission
 * @type {PropTypes.Requireable<function>}
 */
export const onSubmitPropType = PropTypes.func;

/**
 * PropType for focus event handler callback
 * Triggered when an element receives focus
 * @type {PropTypes.Requireable<function>}
 */
export const onFocusPropType = PropTypes.func;

/**
 * PropType for blur event handler callback
 * Triggered when an element loses focus
 * @type {PropTypes.Requireable<function>}
 */
export const onBlurPropType = PropTypes.func;

/**
 * PropType for close/dismiss handler callback
 * Used in modals, alerts, and dismissible components
 * @type {PropTypes.Requireable<function>}
 */
export const onClosePropType = PropTypes.func;

/**
 * PropType for open/show handler callback
 * Used in components that can be programmatically opened
 * @type {PropTypes.Requireable<function>}
 */
export const onOpenPropType = PropTypes.func;

/**
 * PropType for select/selection handler callback
 * Used when an item is selected from a list or dropdown
 * Typically receives the selected item or value
 * @type {PropTypes.Requireable<function>}
 */
export const onSelectPropType = PropTypes.func;

/**
 * PropType for hover event handler callback
 * Triggered when mouse enters an element
 * @type {PropTypes.Requireable<function>}
 */
export const onHoverPropType = PropTypes.func;

/**
 * PropType for scroll event handler callback
 * Triggered when an element is scrolled
 * @type {PropTypes.Requireable<function>}
 */
export const onScrollPropType = PropTypes.func;

/**
 * PropType for dismiss/remove handler callback
 * Used in toasts, notifications, and removable items
 * @type {PropTypes.Requireable<function>}
 */
export const onDismissedPropType = PropTypes.func;

/**
 * PropType for checked/toggle state change handler
 * Used in checkboxes, toggles, and switches
 * Typically receives a boolean value
 * @type {PropTypes.Requireable<function>}
 */
export const onCheckedPropType = PropTypes.func;
